import styled from"@emotion/styled";import{FlexLayout,mediaQuery}from"@wp/src/components/common/grid";import{Body2W400Neutral800,H5W500Neutral900}from"@wp/src/components/common/atoms";export const ImageContainer=styled.div`
  background-image: ${props=>`url('${props.img}')`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;

  ${mediaQuery({width:["344px","344px","768px"],height:["160px","160px","344px"]})}
`;export const TutorialTitle=styled(H5W500Neutral900)`
  display: flex;
  align-items: center;
  width: 100%;
`;export const TutorialSubTitle=styled(Body2W400Neutral800)`
  color: ${props=>props.theme.colors.neutral400};
`;export const TutorialSlideContainer=styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  box-sizing: border-box;
`;export const TutorialContainer=styled.div`
  ${mediaQuery({width:["95%","95%","95%","95%","80%","960px"]})}

  background: ${props=>props.theme.colors.white};
  border-radius: var(--card-border-radius, 8px);
  height: max-content;
  padding: 16px;
  box-sizing: border-box;
`;export const TutorialHeader=styled(FlexLayout)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;export const TutorialContent=styled.div`
  overflow: auto;
`;